import { render, staticRenderFns } from "./ColumnHeader.vue?vue&type=template&id=30c4e57e&"
import script from "./ColumnHeader.vue?vue&type=script&lang=ts&"
export * from "./ColumnHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports